import { NgModule } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe} from '@angular/common';

// Modules
import { MicroempresarioRoutingModule } from './microempresario-routing.module';
import { SharedModule } from '../shared/shared.module';

// Components
import { HomeComponent } from './home/home.component';
import { HomeBienvenidaBannerComponent } from './home/home-bienvenida-banner/home-bienvenida-banner.component';
import { HomeEnviarModalComponent } from './home/home-enviar-modal/home-enviar-modal.component';
import { HomeCancelarModalComponent } from './home/home-cancelar-modal/home-cancelar-modal.component';
import { HomeInfoModalComponent } from './home/home-info-modal/home-info-modal.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
// Solicitud anterior: declarado para conservar el módulo; rutas redirigen a home.
import { SolicitudComponent } from './solicitud/solicitud.component';
import { PropuestasComponent } from './propuestas/propuestas.component';
import { TemplateRegistoComponent } from './template-registo/template-registo.component';
import { EncuestaComponent } from './forms/encuesta/encuesta.component';
// Registro anterior: declarado para conservar el módulo; rutas comentadas en microempresario-routing.

// Templates
import { FormularioPersonaJuridica } from './/forms/persona-juridica/persona-juridica';
import { FormularioPersonaNatural } from './forms/persona-natural/persona-natural';
import { PoliticasModal } from './modals/politicas/politicas.modal';
import { SolicitudJuridicaForm } from './forms/solicitud-juridica/solicitud.juridica.form';
import { FileForm } from './forms/files/files.form';
import { SolicitudNaturalForm } from './forms/solicitud-natural/solicitud.natural.form';
import { ChartComponent } from './chart/chart.component';
import { AceptacionSolicitudCreditoComponent } from './aceptacion-solicitud-credito/aceptacion-solicitud-credito.component';
import { AceptacionEncuestaComponent } from './aceptacion-encuesta/aceptacion-encuesta.component';
import { CambiarContrasenaComponent } from './cambiar-contrasena/cambiar-contrasena.component';
import { TemplateActualizarDatosComponent } from './template-actualizar-datos/template-actualizar-datos.component';
import { ActualizarPersonaNatural } from './forms/actualizar-datos-natural/actualizar-persona-natural';
import { ActualizarPersonaJuridica } from './forms/actualizar-datos-juridica/actualizar-persona-juridica';
import { PageModule } from '../page/page.module';
import { CoreModule } from '../core/core.module';
import { EliminarCuentaComponent } from './eliminar-cuenta/eliminar-cuenta.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfilShellComponent } from './perfil/shell/perfil-shell.component';
import { PerfilHubComponent } from './perfil/hub/perfil-hub.component';
import { PerfilSectionCardComponent } from './perfil/shared/perfil-section-card/perfil-section-card.component';
import { PerfilProgressSectionComponent } from './perfil/shared/perfil-progress-section/perfil-progress-section.component';
import { PerfilProgressGeneralComponent } from './perfil/shared/perfil-progress-general/perfil-progress-general.component';
import { PerfilIntroModalComponent } from './perfil/shared/perfil-intro-modal/perfil-intro-modal.component';
import { PerfilSalirModalComponent } from './perfil/shared/perfil-salir-modal/perfil-salir-modal.component';
import { PerfilEnviarModalComponent } from './perfil/shared/perfil-enviar-modal/perfil-enviar-modal.component';
import { PerfilDocumentoModalComponent } from './perfil/shared/perfil-documento-modal/perfil-documento-modal.component';
import { PerfilStepsStripComponent } from './perfil/shared/perfil-steps-strip/perfil-steps-strip.component';
import { PerfilSectionFooterComponent } from './perfil/shared/perfil-section-footer/perfil-section-footer.component';
import { PerfilSobreTiComponent } from './perfil/sobre-ti/perfil-sobre-ti.component';
import { PerfilSobreNegocioComponent } from './perfil/sobre-negocio/perfil-sobre-negocio.component';
import { PerfilSobreIngresosComponent } from './perfil/sobre-ingresos/perfil-sobre-ingresos.component';
import { PerfilSolicitaCreditoComponent } from './perfil/solicita-credito/perfil-solicita-credito.component';
import { PerfilSolicitudEnviadaComponent } from './perfil/solicitud-enviada/perfil-solicitud-enviada.component';
import { PerfilOfertasComponent } from './perfil/ofertas/perfil-ofertas.component';
import { PerfilOfertasModalesComponent } from './perfil/ofertas/perfil-ofertas-modales.component';
import { PerfilAlianzaComponent } from './perfil/alianza/perfil-alianza.component';
import { PerfilAlianzaHubCardComponent } from './perfil/alianza/perfil-alianza-hub-card.component';
import { HomeSiteFooterComponent } from '../page/home/components/home-site-footer/home-site-footer.component';

@NgModule({
  declarations: [
    TemplateRegistoComponent,
    FormularioPersonaJuridica,
    FormularioPersonaNatural,
    HomeComponent,
    HomeBienvenidaBannerComponent,
    HomeEnviarModalComponent,
    HomeCancelarModalComponent,
    HomeInfoModalComponent,
    LoginComponent,
    PoliticasModal,
    HeaderComponent,
    SolicitudComponent,
    SolicitudNaturalForm,
    SolicitudJuridicaForm,
    FileForm,
    PropuestasComponent,
    EncuestaComponent,
    ChartComponent,
    AceptacionSolicitudCreditoComponent,
    AceptacionEncuestaComponent,
    CambiarContrasenaComponent,
    TemplateActualizarDatosComponent,
    ActualizarPersonaNatural,
    ActualizarPersonaJuridica,
    EliminarCuentaComponent,
    PerfilShellComponent,
    PerfilHubComponent,
    PerfilSectionCardComponent,
    PerfilProgressSectionComponent,
    PerfilProgressGeneralComponent,
    PerfilIntroModalComponent,
    PerfilSalirModalComponent,
    PerfilEnviarModalComponent,
    PerfilDocumentoModalComponent,
    PerfilStepsStripComponent,
    PerfilSectionFooterComponent,
    PerfilSobreTiComponent,
    PerfilSobreNegocioComponent,
    PerfilSobreIngresosComponent,
    PerfilSolicitaCreditoComponent,
    PerfilSolicitudEnviadaComponent,
    PerfilOfertasComponent,
    PerfilOfertasModalesComponent,
    PerfilAlianzaComponent,
    PerfilAlianzaHubCardComponent,
  ],
  imports: [
    MicroempresarioRoutingModule,
    SharedModule,
    CoreModule,
    PageModule,
    NgSelectModule,
    NgbTooltipModule,
    HomeSiteFooterComponent,
  ],
  exports: [HeaderComponent],
  providers: [CurrencyPipe, DatePipe, DecimalPipe]
})
export class MicroempresarioModule { }
